import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import AdminLayout from "./Admin_Layout/AdminLayout";
import { useNavigate } from 'react-router-dom';


const EventsTable = () => {
  const [events, setEvents] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL + "/api/events")
      .then((res) => res.json())
      .then((data) => setEvents(data))
      .catch((err) => console.error("Error fetching events:", err));
  }, []);

  const handleEdit = (event) => {
    console.log("Edit event:", event);
    navigate('/admin-dashboard/edit-events', { state: { data: event } })
    // Add logic to open edit modal or navigate to edit page
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this event?")) {
      try {
        await fetch(process.env.REACT_APP_API_URL + `/api/events/${id}`, { method: "DELETE" });
        setEvents(events.filter((event) => event._id !== id));
      } catch (error) {
        console.error("Error deleting event:", error);
      }
    }
  };

  const parseHTML = (htmlString) => {
    const parser = new DOMParser();
    return parser.parseFromString(htmlString, "text/html").body.textContent;
  };


  return (
    <AdminLayout>
      <TableContainer component={Paper} sx={{ marginTop: 8 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Heading</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Archieved</TableCell>
              <TableCell>Venue</TableCell>
              <TableCell>Details</TableCell>
              {/* <TableCell>Organizer</TableCell> */}
              <TableCell>Image</TableCell>
              <TableCell>Join Link</TableCell>
              <TableCell>Youtube Link</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {events.map((event) => (
              <TableRow key={event._id}>
                <TableCell>{event.heading}</TableCell>
                <TableCell>{parseHTML(event.description).substring(0, 30) + '...'}</TableCell>
                <TableCell>{event.type}</TableCell>
                <TableCell>{event.archieved ? "Yes" : "No"}</TableCell>

                <TableCell>{event.venue}</TableCell>
                <TableCell>{event.details}</TableCell>
                {/* <TableCell>{event.organizer}</TableCell> */}
                <TableCell><img src={process.env.REACT_APP_API_URL + event.imageURL} alt="url of event" width='150px' height='90px'></img></TableCell>
                <TableCell>
                  {event.joinLink}
                </TableCell>
                <TableCell>
                  {event.youtubeLink ? (
                    <a href={event.youtubeLink} target="_blank" rel="noopener noreferrer">
                      YouTube
                    </a>
                  ) : (
                    "N/A"
                  )}
                </TableCell>

                <TableCell>
                  <IconButton onClick={() => handleEdit(event)} color="primary">
                    <Edit />
                  </IconButton>
                  <IconButton onClick={() => handleDelete(event._id)} color="error">
                    <Delete />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </AdminLayout>
  );
};

export default EventsTable;